import { useCsRoutes } from '@shared/api'

import { useSubscriptionStore } from '../model/subscription-store/store'

interface SubscriptionFailedApiOptions {
  onStart?: () => void
  onSuccess?: (data: any) => void
  onError?: (err: any) => void
  onFinish?: () => void
}

interface SubscriptionFailedApiReturn {
  get: (options?: SubscriptionFailedApiOptions) => Promise<any>
}

export const useSubscriptionFailedApi = (): SubscriptionFailedApiReturn => {
  const { $axios } = useNuxtApp()

  const store = useSubscriptionStore()

  const get = async (options?: SubscriptionFailedApiOptions) => {
    const url = useCsRoutes('subscriptions.failed')
    try {
      const { data } = await $axios.get(url!)

      if (data?.data?.error || data?.data?.subscription) {
        store.setPaymentRetryData({
          error: data.data.error,
          subscription: data.data.subscription,
        })

        const retry = true
        store.setBannerPaymentRetry(retry)
        store.setRetryPaymentModal(retry)

      } else {
        store.setPaymentRetryData(null)

        const retry = false
        store.setBannerPaymentRetry(retry)
        store.setRetryPaymentModal(retry)
      }

      options?.onSuccess?.(data.data)
      return data.data
    } catch (err) {
      store.setPaymentRetryData(null)

      const retry = false
      store.setBannerPaymentRetry(retry)
      store.setRetryPaymentModal(retry)

      options?.onError?.(err)
      return null
    }
  }

  return {
    get,
  }
}
